import { AuthUser } from "@app/auth/model/auth-user";
import { AuthState, initialAuthState } from "@app/auth/store/auth.state";
import { createFeatureSelector, createSelector, MemoizedSelector } from "@ngrx/store";

const getLoggedIn = (state: AuthState): boolean => !!state.loggedIn;
const getUser = (state: AuthState) => (state ? state.user : ({} as AuthUser));
const getError = (state: AuthState) => state.error;
const getErrorCode = (state: AuthState) => state.errorCode;
const getPending = (state: AuthState) => !!state.pending;
const getInviteCodeValid = (state: AuthState) => state.isInviteCodeValid;

export const selectAuthStatusState: MemoizedSelector<AuthState, AuthState> = createFeatureSelector<AuthState>("auth");

export const selectGetError = createSelector(selectAuthStatusState, getError);

export const selectGetErrorCode = createSelector(selectAuthStatusState, getErrorCode);

export const selectGetPending = createSelector(selectAuthStatusState, getPending);

export const selectGetLoggedIn = createSelector(selectAuthStatusState, getLoggedIn);

export const selectGetUser = createSelector(selectAuthStatusState, getUser);

export const selectAuthUserEntityId = createSelector(selectAuthStatusState, (state = initialAuthState) => {
    let user = { entityId: null };
    if (state?.user) {
        user = state.user;
    }
    return user.entityId;
});

export const selectInviteCodeValid = createSelector(selectAuthStatusState, getInviteCodeValid);
